import Vue from 'vue'
import VueRouter from 'vue-router'

// Layouts
const MainLayout = () => {
	return import(
		/* webpackChunkName: "MainLayout" */ '@/layouts/MainLayout.vue'
	)
}
// Views
const SmartInboxView = () => {
	return import(
		/* webpackChunkName: "SmartInboxView" */ '@/views/SmartInboxView.vue'
	)
}
const EmailView = () => {
	return import(/* webpackChunkName: "EmailView" */ '@/views/EmailView.vue')
}

Vue.use(VueRouter)

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes: [
		{
			path: '/',
			component: MainLayout,
			redirect: '/inbox',
			children: [
				{
					path: 'inbox',
					name: 'SmartInboxView',
					component: SmartInboxView,
				},
				{
					path: 'inbox/:id',
					name: 'EmailView',
					component: EmailView,
				},
			],
		},
	],
})

export default router
